import React, { useState } from 'react';
import { CheckCircleIcon, DocumentTextIcon, TrashIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Modal from '../../../components/ui/Modal';
import FileDropzone from './FileDropzone';

const DeleteUploadModal = ({ isOpen, deleting, onCancel, onConfirm }) => (
  <Modal isOpen={isOpen} onClose={onCancel} title="Delete uploaded file?" size="sm">
    <p className="upload-modal-text">The file is removed from the server. This cannot be undone.</p>
    <div className="upload-modal-actions">
      <button type="button" className="upload-btn" onClick={onCancel}>Cancel</button>
      <button type="button" className="upload-btn upload-btn-danger" onClick={onConfirm} disabled={deleting}>
        {deleting ? 'Deleting…' : 'Delete file'}
      </button>
    </div>
  </Modal>
);

const PickedFile = ({ upload, onRemove }) => {
  const { file, uploadId, uploading } = upload;
  const progress = Math.min(upload.progress, 100);
  return (
    <div className={`upload-file ${uploadId ? 'done' : ''}`}>
      {uploadId ? <CheckCircleIcon className="upload-file-icon" /> : <DocumentTextIcon className="upload-file-icon" />}
      <div className="upload-file-meta">
        <div className="upload-file-name">{file.name}</div>
        <div className="upload-file-sub">
          {(file.size / 1024 / 1024).toFixed(1)} MB
          {uploadId && ' · uploaded'}
          {uploading && ` · uploading ${progress}%`}
        </div>
        {uploading && (
          <div className="upload-progress"><div style={{ width: `${progress}%` }} /></div>
        )}
      </div>
      {!uploading && (
        <button
          type="button"
          className="upload-icon-btn"
          onClick={onRemove}
          title={uploadId ? 'Delete uploaded file' : 'Remove file'}
        >
          {uploadId ? <TrashIcon /> : <XMarkIcon />}
        </button>
      )}
    </div>
  );
};

/** The "File" card: drop zone until a file is picked, then its upload progress and a remove/delete button. */
export default function UploadFileCard({ upload }) {
  const [confirmDelete, setConfirmDelete] = useState(false);
  const removeFile = () => (upload.uploadId ? setConfirmDelete(true) : upload.clear());
  const deleteFile = async () => {
    if (await upload.deleteUploaded()) setConfirmDelete(false);
  };

  return (
    <section className="upload-card">
      <h2>File</h2>
      {upload.file ? <PickedFile upload={upload} onRemove={removeFile} /> : <FileDropzone onFileSelected={upload.select} />}
      {upload.error && <p className="upload-error">{upload.error}</p>}

      <DeleteUploadModal
        isOpen={confirmDelete}
        deleting={upload.deleting}
        onCancel={() => setConfirmDelete(false)}
        onConfirm={deleteFile}
      />
    </section>
  );
}
